import styled from 'styled-components';
import { Link } from 'react-router-dom';

// images
import { ReactComponent as FooterLogoImageSvg } from '@src/images/footer/keyplay-logo-mobile-footer.svg';

const DefaultFooterContainer = styled.footer`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding-right: 40px;
  padding-left: 40px;
`;

export const DesktopFooterContainer = styled(DefaultFooterContainer)`
  background-color: #000;
`;
export const MobileFooterContainer = styled(DefaultFooterContainer)`
  background-color: #000;
  padding-top: 30px;
  padding-bottom: 30px;
  ${(props) => props.theme.mixin.convertMobileWidth('padding-right', 50)};
  ${(props) => props.theme.mixin.convertMobileWidth('padding-left', 50)};
`;

export const MobileFooterContainerTop = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 12px;
`;
export const MobileFooterContainerMiddle = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  width: 100%;
  color: white;
  font-size: 12px;
`;

export const MobileFooterContainerMiddleContent = styled.a`
  display: inline-block;
  text-align: center;
  width: 100%;
`;

export const MobileFooterCopyRight = styled.span`
  margin-top: 10px;
  text-align: center;
`;
export const MobileFooterTermList = styled.div`
  text-align: center;
  width: 100%;
`;

export const MobileFooterContainerBottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 14px;
  width: 100%;
  font-size: 12px;
  color: #fff;

  ${MobileFooterTermList} + ${MobileFooterCopyRight} {
    margin-top: 12px;
  }
`;

export const FooterLogo = styled(FooterLogoImageSvg)``;

export const FooterTopWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 1260px;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding-top: 23px;
  padding-bottom: 23px;
`;

export const Text = styled(Link)`
  color: white;
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: -0.45px;
  line-height: normal;
  & + & {
    margin-left: 28px;
  }
  cursor: pointer;
  text-decoration: none;

  @media screen and (max-width: ${(props) => props.theme.breakPoint.mobile}px) {
    font-size: inherit;
    color: inherit;
  }
`;
// export const Line = styled.div`
//   height: 1px;
//   width: 100%;
//   opacity: 0.2;
//   background-color: #393939;
//   margin-bottom: 41px;
// `;

export const FooterBottomWrapper = styled.div`
  width: 100%;
  max-width: 1260px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 47px;
`;

export const Logo = styled.img`
  margin-bottom: 7px;
  width: 155px;
  height: 44px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
`;

export const CopyrightText = styled.span`
  display: block;
  color: white;
  font-size: 13px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: normal;
  line-height: 28px;
  text-align: right;
`;

export const BottomBoldText = styled.span`
  color: white;
  font-size: 17px;
  font-weight: 500;
  letter-spacing: -0.45px;
  line-height: 34px;

  font-style: normal;
  letter-spacing: normal;
`;

// const BottomSeparator = styled.div`
//   display: inline-block;
//   margin: 0 10px;
//   width: 1px;
//   height: 14px;
//   background-color: #393939;
//   opacity: 0.3;
// `;
